import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";

export function FadeOutLayersCommand(layers: Layers[], time: number = 400, delay: number = 0) {
    return new Contract<void>(resolve => {
        const obj = { value: 1};
        
        const update = () => {
            for(let layer of layers) {
                layer.container.alpha = obj.value;
            }
        }
        new TweenJS.Tween(obj)
        .to({value: 0}, time)
        .delay(delay)
        .onUpdate(update)
        .onComplete(() => {
            for(let layer of layers) {
                layer.container.alpha = 1;
            }
            for(let layer of layers) {
                layer.hide();
            }
            resolve(null);
        })
        .start();
    })
}

export function FadeInLayersCommand(layers: Layers[], time: number = 400, delay: number = 0) {
    return new Contract<void>(resolve => {        
        const obj = { value: 0};
        for(let layer of layers) {
            layer.show();
        }
        const update = () => {
            for(let layer of layers) {
                layer.container.alpha = obj.value;
            }
        }
        update();
        new TweenJS.Tween(obj)
        .to({value: 1}, time)
        .delay(delay)
        .onUpdate(update)
        .onComplete(() => {           
            resolve(null);
        })
        .start();
    })
}